import { cn } from '@/lib/utils'

/**
 * Campo de moeda brasileira (R$). Exibe formatado (1.234,56) e emite o valor
 * numérico como string ("1234.56") via onChange, compatível com o backend.
 *
 * Uso: <CurrencyInput value={valorTotal} onChange={(v) => set('valorTotal', v)} />
 */
export function CurrencyInput({ value, onChange, className, disabled, ...props }) {
  // value chega como número/string numérica ("1234.56"). Converte para centavos.
  const cents = toCents(value)
  const display = cents === null ? '' : formatCents(cents)

  function handleChange(e) {
    const digits = e.target.value.replace(/\D/g, '')
    if (digits === '') {
      onChange('')
      return
    }
    const newCents = parseInt(digits, 10)
    onChange((newCents / 100).toFixed(2))
  }

  return (
    <div className="relative">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">R$</span>
      <input
        type="text"
        inputMode="numeric"
        value={display}
        onChange={handleChange}
        disabled={disabled}
        placeholder="0,00"
        className={cn(
          'flex h-10 w-full rounded-md border border-border bg-input pl-9 pr-3 py-2 text-sm text-right',
          'placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        {...props}
      />
    </div>
  )
}

function toCents(value) {
  if (value === '' || value === null || value === undefined) return null
  const n = Number(value)
  if (Number.isNaN(n)) return null
  return Math.round(n * 100)
}

function formatCents(cents) {
  return (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
